function TotalPayment ({totalqtyprice,totalMrpPrice, shippingCharges, currentCoupon,  couponDiscountAmount, totalAmountOfProduct}){
    return (
        <>
            {/* <div className="common-heading">
                <h6>Total Payment</h6>
            </div> */}
            <div className="payment-summary">
                {/* <div className="summary-row">
                    <span className="sub-total">Sub Total</span>
                    <div className="price-details">
                        <div className="current-price">
                            <span className="sub-total-strike">₹ {totalMrpPrice.toLocaleString("en-IN")}</span>{totalqtyprice.toLocaleString("en-IN")}
                        </div>
                    </div>
                </div>
                <div className="summary-row">
                    <span className="charges">Shipping Charges</span>
                    <div className="price-details">
                        <div className="original-price">
                            {shippingCharges.toLocaleString("en-IN")} <span className="orig-price">₹ 0</span>
                        </div>
                    </div>
                </div>
                {currentCoupon && (
                    <div className="summary-row">
                        <span className="charges">Discount ({currentCoupon})</span>
                        <div className="discount">- {couponDiscountAmount}</div>
                    </div>
                )} */}

                <div className="total-row ">
                    <span>Total</span>
                    <div className="total-price">₹{totalAmountOfProduct.toLocaleString("en-IN")}</div>
                </div>
            </div>
        </>
    )
}
export default TotalPayment;